import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  z-index: 10;
  bottom: 30px;
  right: 60px;
  font-size: 30px;
  text-align: center;
  cursor: ${(props) => (props['aria-disabled'] ? 'not-allowed' : 'pointer')};
  padding: 1rem;

  * {
    color: #00b1f1;
  }

  .icon * {
    animation: up-down 1s ease-in-out infinite alternate;
  }

  div {
    font-size: 18px;
    font-weight: 600;
    color: #00b1f1;
  }
  :hover {
    div {
      transform: scale(1.1);

      transition: all 0.1s ease-in-out;
    }
  }

  @keyframes up-down {
    0% {
      transform: translateY(3px);
    }
    100% {
      transform: translateY(0px);
    }
  }

  .rotate {
    animation: rotate 1s ease-in-out infinite;

    @keyframes rotate {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
        transition: all 0.1s ease-in-out;
      }
    }
  }
`;
